import React from 'react';
import { motion } from 'framer-motion';
import { Zap, DollarSign, Award, ThumbsUp, CheckCircle2 } from 'lucide-react';
const reasons = [{
  title: 'FAST RESPONSE TIMES',
  description: "Electrical issues don't wait. We offer prompt scheduling and emergency services.",
  icon: Zap
}, {
  title: 'UPFRONT PRICING',
  description: "No hidden fees. You'll know exactly what the job costs before we start.",
  icon: DollarSign
}, {
  title: 'LICENSED EXPERTS',
  description: 'Highly trained, fully licensed, and insured professionals who do it right.',
  icon: Award
}, {
  title: 'SATISFACTION GUARANTEED',
  description: "We stand behind our work. If you're not 100% satisfied, we'll make it right.",
  icon: ThumbsUp
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-[#2d2d2d]" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-191">
          {/* Photo side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-192">
            <div className="rounded-3xl overflow-hidden relative" data-id="element-193">
              <img src="https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=800&q=80" alt="Electrician at work" className="w-full h-[500px] object-cover" data-id="element-194" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2d2d2d]/60 to-transparent" data-id="element-195" />
            </div>

            {/* Floating stats card */}
            <div className="absolute -bottom-6 -right-4 sm:right-8 bg-[#FFD700] rounded-2xl p-6 shadow-2xl" data-id="element-196">
              <div className="text-4xl font-extrabold text-[#1f1f1f]" data-id="element-197">500+</div>
              <div className="text-sm font-bold text-[#2d2d2d] uppercase tracking-wide" data-id="element-198">
                Projects Completed
              </div>
            </div>

            {/* Second floating card */}
            <div className="absolute top-6 -left-4 sm:left-8 bg-[#1f1f1f] border border-[#3a3a3a] rounded-2xl p-4 shadow-2xl flex items-center gap-3" data-id="element-199">
              <div className="w-10 h-10 bg-[#FFD700] rounded-full flex items-center justify-center" data-id="element-200">
                <Award className="w-5 h-5 text-[#1f1f1f]" data-id="element-201" />
              </div>
              <div data-id="element-202">
                <div className="text-white font-bold text-sm" data-id="element-203">
                  Licensed & Insured
                </div>
                <div className="text-gray-400 text-xs" data-id="element-204">NV State Certified</div>
              </div>
            </div>
          </motion.div>

          {/* Content side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-205">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 uppercase" data-id="element-206">
              WHY NEVADA CHOOSES <br data-id="element-207" />
              <span className="text-[#FFD700]" data-id="element-208">CABALLERO'S ELECTRIC</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-209">
              We've built our reputation on reliability, transparency, and
              unmatched technical expertise. We don't just fix electrical
              problems; we provide lasting solutions for your home or business.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-210">
              {['Locally owned and operated', 'Fully licensed, bonded, and insured', 'Clean, professional technicians', 'Respect for your property'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium" data-id="element-211">
                  <CheckCircle2 className="w-6 h-6 text-[#FFD700] shrink-0" data-id="element-212" />
                  {item}
                </li>)}
            </ul>

            <div className="grid grid-cols-2 gap-4 mb-10" data-id="element-213">
              {reasons.map((reason, index) => <div key={index} className="bg-[#3a3a3a] p-5 rounded-2xl border border-[#444]" data-id="element-214">
                  <reason.icon className="w-6 h-6 text-[#FFD700] mb-3" data-id="element-215" />
                  <h3 className="text-sm font-bold text-white uppercase tracking-wide" data-id="element-216">
                    {reason.title}
                  </h3>
                </div>)}
            </div>

            <button className="bg-[#FFD700] hover:bg-[#e6c200] text-[#1f1f1f] px-8 py-4 rounded-full font-bold text-lg transition-colors" data-id="element-217">
              Get Your Free Quote
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}